import type { ReactNode } from 'react'
import s from './Chip.module.scss'

export type ChipTone = 'neutral' | 'info' | 'good' | 'warn' | 'bad' | 'outline'

/**
 * Eine kurze Angabe in einer Pille — Zustand, Einordnung, Kennzeichen.
 *
 * Die Tonalität ist sachlich und nicht fachlich: `good` heißt "die gute
 * Stufe", nicht "DIP CONFIRMED". Was gut ist, weiß die Seite, nicht der Chip.
 */
export function Chip({ tone = 'neutral', children }: {
  tone?: ChipTone
  children: ReactNode
}) {
  return <span className={s[tone]}>{children}</span>
}
